<template>
  <b-form-group label="Status">
    <multiselect
      label="name"
      track-by="value"
      :options="options"
      :disabled="disabledSelect"
      v-model="valorStatusProjeto"
      selected-label=""
      :class="{ 'is-valid': valorStatusProjeto }"
      placeholder="Selecione o status do projeto"
      deselect-label=""
      select-label=""
    >
      <span slot="noResult">Nenhum status encontrado</span>
      <span slot="noOptions">Nenhum status disponível</span>
    </multiselect>
  </b-form-group>
</template>

<script>
import Multiselect from "vue-multiselect";
import { StatusProjetoService } from "../../../../../services/astec/statusProjeto";

export default {
  name: "SelectStatusProjeto",
  components: { Multiselect },

  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    disabledSelect: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      options: [],
      valorStatusProjeto: this.value
    };
  },
  watch: {
    value(newValue) {
      this.valorStatusProjeto = newValue;
    },
    valorStatusProjeto(newValue) {
      this.$emit("input", newValue);
    }
  },
  async mounted() {
    try {
      this.options = await StatusProjetoService.buscarLkpStatusProjeto();
    } catch (error) {
      console.error(error);
    }
  },
  computed: {
    isDisabled() {
      return this.disabledSelect;
    }
  }
};
</script>

<style lang="css" scoped>
@keyframes pulse-danger {
  0% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(220, 53, 69, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(220, 53, 69, 0);
  }
}
</style>
